<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      v-if="Ekstre"
      :data="Ekstre.Ekstre"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      :row-class-name="TableClass"
    >
      <el-table-column
        label="Tarih"
        prop="Tarih"
        width="100">
      </el-table-column>
      <el-table-column
        label="Türü"
        prop="Turu"
        width="130">
      </el-table-column>
      <el-table-column
        v-if="!data.Bina_id"
        label="Site/Bina"
        prop="Bina"
        width="300">
      </el-table-column>
      <el-table-column
        label="Evrak No"
        width="100">
        <template slot-scope="scope">
          <a v-if="scope.row.Tur==3 || scope.row.Tur==4" @click="MakbuzGetir(scope.row.eNo)">
            <span>{{ scope.row.eNo }}</span>
          </a>
          <span v-if="scope.row.Tur==1 || scope.row.Tur==2">{{ scope.row.eNo }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Açıklama"
        prop="Aciklama">
      </el-table-column>
      <el-table-column
        label="Borç"
        prop="Borc"
        width="100"
        align="right">
      </el-table-column>
      <el-table-column
        label="Alacak"
        prop="Alacak"
        width="100"
        align="right">
      </el-table-column>
      <el-table-column
        label="Kalan"
        prop="Kalan"
        width="100"
        align="right">
      </el-table-column>
    </el-table>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="SayfaYukle"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
import Yukleniyor from "../../../Doc/Yukleniyor";
import MakbuzDetay from "../../Vezne/MakbuzDetay";

export default {
  components: {MakbuzDetay, Yukleniyor},
  props: {
    data: {
      type: Object,
      require: true,
    },
    Yenile: Boolean
  },
  data() {
    return {
      mNo: 0,
      MakbuzDetayModal: null,
      Height: 0,
      search: null,
      lo: true,
      Ekstre: {
        Ekstre: null,
        AltToplam: {
          Borc: 0,
          Alacak: 0,
          Kalan: 0,
        }
      }
    }
  },
  methods: {
    MakbuzGetir(mNo) {
      this.mNo = mNo;
      this.MakbuzDetayModal = true
    },
    TableClass({row}) {
      return row.TableClass
    },
    TableFooter() {
      const sums = [];
      if (this.data.Bina_id) {
        sums[4] = this.Ekstre.AltToplam.Borc;
        sums[5] = this.Ekstre.AltToplam.Alacak;
        sums[6] = this.Ekstre.AltToplam.Kalan;
      } else {
        sums[5] = this.Ekstre.AltToplam.Borc;
        sums[6] = this.Ekstre.AltToplam.Alacak;
        sums[7] = this.Ekstre.AltToplam.Kalan;
      }
      return sums;
    },
    SayfaYukle() {
      this.lo = true
      this.MakbuzDetayModal = false
      this.$store.dispatch("Post", {...this.data, path: 'muhasebe/ekstre/cari'})
        .then(response => {
          this.Ekstre = response;
          this.lo = false
          this.Height = window.innerHeight - 150
        })
    },


  },
  created() {
    this.SayfaYukle();
  },
  computed: {
    rSAyfaYukle() {
      return this.Yenile
    },
  },
  watch: {
    rSAyfaYukle() {
      if (this.Yenile) this.SayfaYukle();
    },
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/cari/CariEkstre.vue